<!-- 扫码展示页 -->
<template>
<div class="wrapper">
   <div id="scan" class="container">
    <img :src="landingPage" alt="">
    <div class="fix-bottom">
      <!-- 注册领取 -->
      <vanButton
        class="registered-btn"
        @click="goToregister"
      >{{ $t('app.label.registration') }}</vanButton>
    </div>
  </div>
</div>
</template>

<script>
import { Button as vanButton } from 'vant'
import qs from 'qs'
import { apiGet } from '@/services'
import landingPage from '@/assets/images/scanIndex/landingPage.png'
export default {
  name: 'scanIndex',

  components: { vanButton },

  data() {
    return {
      landingPage,
      // 支持平台图标
      platformList: ['iconzhichipingtai-amazon-cai', 'iconzhichipingtai-ebay-cai', 'iconzhichipingtai-sumaitong-cai', 'iconzhichipingtai-cd-cai', 'iconzhichipingtai-dianjiang-cai', '']
    }
  },
  mounted() {
    const observer = new ResizeObserver((entries) => {
    for (const entry of entries) {
        if (entry.contentRect.width >= 750) {
          document.querySelector('.container').classList.add('ignore_container')
        }
        if ((entry.contentRect.width < 750)) {
          document.querySelector('.container').classList.remove('ignore_container')
        }
      }
    })
    observer.observe(document.documentElement)
  },
  methods: {
    // 跳转到会员端,后端返回直接跳转
    goToregister() {
      const uri = qs.parse(location.search.slice(1))
      // // 兼容旧链接
      const code = uri.hmpl
      apiGet('partner/open/inviteLink', { partnerNo: code})
        .then(res => {
          if (res.code === '0000') {
            window.location.href = res.data
          } else {
            this.$notify.error(res.msg)
          }
        })
      }
  }
}
</script>

<style lang="less" scoped>
.ignore_container, .container {
  min-height: 100vh;
  position: relative;

  img{
    width: 100%;
    margin-top: -88px;
  }

  .fix-bottom {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;

    .registered-btn {
      height: 40px;
      width: 260px;
      border-radius: 20px;
      background: #643bff;
      font-size: 16px;
      color: #ffffff;
      font-weight: 600;
      border: none;
      margin-bottom: 40px;
    }
  }
}
.ignore_container {
  max-width: 750px;
  margin: 0 auto;
}
</style>
